import { FlexCol } from "@shared";
import { StakingPage } from "./components/StakingPage";

export const StakingTab = () => {
  return (
    <FlexCol className="gap-8">
      <StakingPage />
    </FlexCol>
  );
};
